var installedModules = {};
var moduleToHandlerMapping = {
	52768: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	2944: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.0 || ^18.0.0 || ^19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	16045: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	30685: {
		getter: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	32887: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 16.8.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	35514: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18 || ^19",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	66151: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.6.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	71105: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.8.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	77238: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.9.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	79673: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 16.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	93503: {
		getter: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	99375: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	99809: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	21416: {
		getter: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.9.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	20438: {
		getter: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.3 || ^17.0.0 || ^18.0.0 || ^19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	45791: {
		getter: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.6.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	84998: {
		getter: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.0.0 || ^18.0.0 || ^19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"416": [
		21416
	],
	"438": [
		20438
	],
	"447": [
		45791,
		84998
	],
	"768": [
		52768
	],
	"778": [
		2944,
		16045,
		30685,
		32887,
		35514,
		66151,
		71105,
		77238,
		79673,
		93503,
		99375,
		99809
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}